import SDK from './core';

export const generateInviteLink = () => SDK.generateInviteLink();

export const shareInviteViaEmail = (emails, inviteLink) => SDK.shareInviteViaEmail(emails, inviteLink);

export const getRequestUserList = data => SDK.getRequestUserList(data);

export const deleteAllRequests = timestamp => SDK.deleteAllRequests(timestamp);

export const acceptInvitation = userJid => SDK.acceptInvitation(userJid);

export const validateInviteLink = token => SDK.validateInviteLink(token);

export const getInviteStatus = userJid => SDK.getInviteStatus(userJid);

export const getInviteRequestInfo = userJid => SDK.getInviteRequestInfo(userJid);
